import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../utils";
export const Loading = ({ className }) => {
    return _jsx("div", { className: cn("w-fit h-fit animate-spin", className), children: "\u231B" });
};
